The supported methods of applying to job ads posted by the hirer.

All SEEK hirers can use SEEK's Apply Form by omitting the `ApplicationMethod` object when posting.
This enumerates additional application methods SEEK has configured for the hirer.

Currently, the following application method codes are defined:

- `ApplicationUri` indicates that job ads can link out to an external apply form.
